import { logger } from '@belong/logging/logger';
import ContentGQL from 'src/services/ContentGQL';
import { ISupportCategory } from '@belong/types/support';
import { FSupportArticle, transformCategories } from 'src/models/articles';
import CategoryModel from 'src/models/Categories';
import { IPageError } from 'src/core/types';
import { IArticleLinkGroup } from 'src/components/sections/SectionLinkGroups/ArticleLinkGroup';

export interface ICategoryPageData {
  articles: IArticleLinkGroup[];
}

export const transformArticleData = (
  categoryModel: CategoryModel,
  categories: string[],
  articleData: any[]
): IArticleLinkGroup[] => {
  return categories.map(categoryId => {
    const { id = '', label = '' } = categoryModel.getCategoryById(categoryId) || {};
    return {
      id,
      label,
      items: articleData
        .filter(article => article.categories.includes(categoryId))
        .map(article => ({
          ...FSupportArticle(article, categoryModel),
          categories: transformCategories(categoryModel, categoryId, article.categories)
        }))
    };
  });
};

async function loadCategoryPageData(
  categoryModel: CategoryModel,
  category: ISupportCategory
): Promise<ICategoryPageData | IPageError> {
  const childCategories = (category?.children.length ? category.children : [category]).map(cat => cat!.id);
  let articleLinkData;

  try {
    // load contentful data
    articleLinkData = await ContentGQL.getArticlesByCategory(childCategories);
    if (!articleLinkData?.length) {
      throw new Error();
    }
  } catch (err) {
    logger.error(`Could not load articles for category '${category.id}' (${category.label})`, err.message);
    return { statusCode: 404 };
  }

  try {
    // transform article data, retaining ordering
    const articles = transformArticleData(categoryModel, childCategories, articleLinkData);
    return { articles };
  } catch (err) {
    logger.error('Error transforming Article data', err.message);
    return { statusCode: 500 };
  }
}

export default loadCategoryPageData;
